<template>
  <button
    type="button"
    class="pmi-container"
    @click="selectPaymentMethod"
  >
    <div
      :class="[
        selected ? 'active' : null,
        'radio-container',
      ]"
    >
      <div
        v-if="selected"
        class="radio-dot"
      />
    </div>
    <div class="flex-row align-center">
      <div class="pmi-image-container">
        <PaymentMethodIcon
          :paymentMethod="paymentMethod"
        />
      </div>
      <div
        v-if="paymentMethod.bank_account"
        class="flex-column margin-left-4"
      >
        <div class="pmi-header">
          {{ paymentMethod.bank_account.bank_name }}
        </div>
        <div class="pmi-body">
          Ending in... {{ paymentMethod.bank_account.last4 }}
        </div>
      </div>
      <div
        v-else-if="paymentMethod.card"
        class="flex-column margin-left-4"
      >
        <div class="pmi-header">
          {{ paymentMethod.card.brand.toUpperCase() }}
        </div>
        <div class="pmi-body">
          Ending in... {{ paymentMethod.card.last4 }}
        </div>
      </div>
    </div>
  </button>
</template>

<script>
import PaymentMethodIcon from '../PaymentMethodIcon.vue';

export default {
  name: 'PaymentMethodItem',
  components: {
    PaymentMethodIcon,
  },
  props: {
    selected: Boolean,
    paymentMethod: Object,
    onSelect: Function,
  },
  methods: {
    selectPaymentMethod() {
      this.onSelect(this.paymentMethod);
    },
  },
};
</script>

<style lang="scss" scoped>

.pmi-container {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 8px 4px;
  border-radius: 4px;
  background-color: $N5;
  margin-bottom: 12px;
  width: 100%;

  &:hover {
    background-color: $N10;
  }

  .radio-container {
    border-radius: 50%;
    width: 25px;
    height: 25px;
    border: 2px solid $N100;
    margin-right: 12px;
    display: flex;
    align-items: center;
    justify-content: center;

    &.active {
      border-color: $NBLUE100;
    }

    .radio-dot {
      width: 17px;
      height: 17px;
      background-color: $NBLUE100;
      border-radius: 50%;
    }
  }

  .pmi-header {
    font-size: 1rem;
    font-weight: 700;
    color: $N90;
  }

  .pmi-body {
    font-size: 0.875rem;
    color: $N80;
    font-weight: 500;
    text-align: left;
  }
}
</style>
